import { FC, useCallback } from "react";

import { setResourceDetailsCoverageRelatedData } from "@/store/resource-details/resourceDetailsSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { getResourceDetailsResourceCoverageDataThunk } from "@/store/resource-details/thunks/coverage-data/getResourceDetailsResourceCoverageDataThunk";
import { resourceDetailsCoverageDataPointSelector } from "@/store/resource-details/selectors/coverage-data/options/resourceDetailsCoverageDataPointSelector";
import { DateDataPoint } from "@/services/cloudchipr.api";
import { ResourceDetailsDataPointSelector } from "@/components/pages/common/resource-details/components/content/common/ResourceDetailsDataPointSelector";

export const ResourceDetailsCoverageTabDataPointSelector: FC = () => {
  const dispatch = useAppDispatch();

  const dataPoint = useAppSelector(resourceDetailsCoverageDataPointSelector);

  const changeHandler = useCallback(
    (point: DateDataPoint) => {
      dispatch(
        setResourceDetailsCoverageRelatedData({
          data_point: point,
        }),
      );
      dispatch(getResourceDetailsResourceCoverageDataThunk());
    },
    [dispatch],
  );

  if (!dataPoint) {
    return null;
  }

  return (
    <ResourceDetailsDataPointSelector
      dataPoint={dataPoint}
      onChange={changeHandler}
    />
  );
};
